export default "__VITE_ASSET__52536597__"